import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const DropdownMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 226px;
    min-height: 52px;
    padding: 18px 0;

    background: ${Colors.WHITE};
    border-radius: ${Spacing["2XS"]}px;
    box-shadow: 0 ${Spacing.SM}px 20px rgba(0, 0, 0, 8%);
`;

export const DropdownAction = styled.div`
    cursor: pointer;

    display: flex;
    align-items: center;

    min-width: 226px;
    height: 36px;
    padding-left: 37px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
    color: ${Colors.Black.V50};

    :hover,
    :focus {
        background-color: ${Colors.Gray.V50};
    }
`;
